/* VIPA customer-friendly model results:
   A model URL keeps Shopify's strict wiper-only query while titles
   and search input show normal language. Scoped to this exact URL shape.
   No changes to product data, filter facets, or search API.
*/
(function() {
  'use strict';
  if (window.location.pathname !== '/search') return;
  var params = new URLSearchParams(window.location.search);
  var original = params.get('q') || '';
  var match = original.match(/^title:"([^"]+)"\s+AND\s+title:wiper$/i);
  if (!match) return;
  var model = match[1].trim();
  var friendly = model + ' Wiper Blades';
  function apply() {
    var container = document.querySelector('.template-search');
    if (!container) return;
    document.title = friendly + ' | VIPA Car Parts';
    var heading = container.querySelector('.template-search__header h1');
    if (heading) heading.textContent = friendly;
    var input = container.querySelector('#Search-In-Template');
    if (!input) return;
    if (input.value.indexOf('title:') !== -1 || input.value.toLowerCase().indexOf('and title:wiper') !== -1) {
      input.value = friendly;
    }
    if (!input.hasAttribute('data-vipa-customer-labelled')) {
      input.setAttribute('data-vipa-customer-labelled', '1');
      var form = input.closest('form');
      if (form) form.addEventListener('submit', function() {
        if (input.value.trim().toLowerCase() === friendly.toLowerCase()) {
          input.value = original;
        }
      }, true);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, {once:true});
  } else {
    apply();
  }
  window.addEventListener('load', apply, {once:true});
})();
